import React from 'react';
import { X, BarChart3 } from "lucide-react";
import { DEFAULT_PLANS } from "../../config/constants";

const DailyQuotaModal = ({ userData, plansMap, onClose }) => {
    const planId = (userData?.planId || 'A').toUpperCase();
    const currentPlansMap = plansMap || DEFAULT_PLANS;
    const planConfig = currentPlansMap[planId] || DEFAULT_PLANS[planId] || DEFAULT_PLANS['A'];

    const lastDate = userData?.lastActiveAt?.toDate().toDateString();
    const isToday = lastDate === new Date().toDateString();
    
    const usedSolved = isToday ? (userData?.todaySolved || 0) : 0;
    const usedQuizzes = isToday ? (userData?.todayQuizzes || 0) : 0;
    const usedConcepts = isToday ? (userData?.todayConcepts || 0) : 0;

    const renderProgressBar = (label, used, limit, colorClass) => {
        const isUnlimited = Number(limit) === -1;
        const percentage = isUnlimited ? 100 : Math.min(100, (used / limit) * 100);
        const text = isUnlimited ? "無限暢用" : `${used} / ${limit}`;
        
        return (
            <div className="mb-4">
                <div className="flex justify-between items-end mb-1">
                    <span className="text-xs font-bold text-slate-600">{label}</span>
                    <span className={`text-xs font-black ${colorClass}`}>{text}</span>
                </div>
                <div className="h-2.5 w-full bg-slate-100 rounded-full overflow-hidden">
                     <div className={`h-full rounded-full transition-all duration-500 ${isUnlimited ? 'bg-gradient-to-r from-yellow-400 to-amber-500 w-full' : (percentage >= 100 ? 'bg-red-500' : 'bg-slate-800')}`} style={{ width: isUnlimited ? '100%' : `${percentage}%` }}></div>
                </div>
            </div>
        );
    };

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in" onClick={onClose}>
            <div className="bg-white rounded-[2rem] w-full max-w-sm overflow-hidden shadow-2xl relative" onClick={e => e.stopPropagation()}>
                 <div className="bg-slate-900 p-6 text-white relative">
                    <button onClick={onClose} className="absolute top-4 right-4 p-2 bg-white/10 rounded-full hover:bg-white/20 transition-all"><X size={18}/></button>
                    <div className="flex items-center gap-3">
                        <BarChart3 size={28} className="text-white"/>
                        <h3 className="text-xl font-black tracking-wide">今日額度狀態</h3>
                    </div>
                     <p className="text-white/80 text-xs font-medium ml-10">每日 00:00 自動重置</p>
                </div>
                <div className="p-8">
                    {renderProgressBar("⚡️ AI 智能解析", usedSolved, planConfig.dailyLimit, "text-violet-600")}
                    {renderProgressBar("🔍 舉一反三", usedQuizzes, planConfig.similarLimit, "text-blue-600")}
                    {renderProgressBar("💡 重點整理", usedConcepts, planConfig.conceptLimit, "text-amber-600")}
                    
                    <div className="mt-6 p-4 bg-slate-50 rounded-xl border border-slate-100 text-center">
                       <p className="text-xs text-slate-400 mb-1">若額度不足，將自動扣除帳戶點數</p>
                        <p className="text-sm font-bold text-slate-600">目前點數：<span className="text-yellow-500 font-black">{userData?.points}</span> 點</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DailyQuotaModal;
